"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IconWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
const ControlsWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ControlsWrapper",
  class: "pl-c1u5mwiv"
});
const ButtonShared = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "ButtonShared",
  class: "pl-b5bq4x"
});
const PrevButton = /*#__PURE__*/(0, _react2.styled)(ButtonShared)({
  name: "PrevButton",
  class: "pl-pw7ctm2"
});
const NextButton = /*#__PURE__*/(0, _react2.styled)(ButtonShared)({
  name: "NextButton",
  class: "pl-n15vva9l"
});
const IconWrapper = exports.IconWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconWrapper",
  class: "pl-imcv33z"
});

/**
 * CarouselControl Component.
 *
 * @param {Object} props React props
 * @param {Function} props.handlePrevButtonClick Function to handle previous button click
 * @param {Function} props.handleNextButtonClick Function to handle next button click
 * @param {String} props.prevButtonAriaLabel Aria label for previous button
 * @param {String} props.nextButtonAriaLabel Aria label for next button
 * @param {String} props.prevButtonTrackingName Optional tracking name for previous button
 * @param {String} props.nextButtonTrackingName Optional tracking name for next button
 * @returns {React.ReactElement} CarouselControl Component
 * @public
 */

function CarouselControl({
  handlePrevButtonClick,
  handleNextButtonClick,
  prevButtonAriaLabel,
  nextButtonAriaLabel,
  prevButtonTrackingName = 'carousel-prev',
  nextButtonTrackingName = 'carousel-next'
}) {
  return /*#__PURE__*/_react.default.createElement(ControlsWrapper, {
    className: "controls-wrapper",
    "data-cy": "controls-wrapper"
  }, /*#__PURE__*/_react.default.createElement(PrevButton, (0, _extends2.default)({
    className: "prev-button",
    onClick: handlePrevButtonClick,
    "aria-label": prevButtonAriaLabel
  }, _patternLibraryUtils.tracking.create(prevButtonTrackingName, true, true)), /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    "aria-hidden": "true"
  }))), /*#__PURE__*/_react.default.createElement(NextButton, (0, _extends2.default)({
    className: "next-button",
    onClick: handleNextButtonClick,
    "aria-label": nextButtonAriaLabel
  }, _patternLibraryUtils.tracking.create(nextButtonTrackingName, true, true)), /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-left",
    "aria-hidden": "true"
  }))));
}
var _default = exports.default = CarouselControl;
CarouselControl.propTypes = {
  handlePrevButtonClick: _propTypes.default.func.isRequired,
  handleNextButtonClick: _propTypes.default.func.isRequired,
  prevButtonAriaLabel: _propTypes.default.string.isRequired,
  nextButtonAriaLabel: _propTypes.default.string.isRequired,
  prevButtonTrackingName: _propTypes.default.string,
  nextButtonTrackingName: _propTypes.default.string
};